import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import Loader from '../../components/Loader';
import BASE_URL from '../../config/config';
import { cabecerasAuth, claves } from '../../queries/cliente';
import Verificacion from '../../components/Verificacion';
import Suspendido from '../../components/Suspendido';
import { FiClock, FiInbox, FiCheck } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { metaCategoria } from './admin/servicios/categorias';

const Servicios = () => {
    const { t } = useTranslation();


    const navigate = useNavigate();

    const token = localStorage.getItem('AuthToken');
    const tokenInfo = token ? jwtDecode(token) : {};

    // Los mismos servicios que ve el admin en la ficha del usuario
    const consultaServicios = useQuery({
        queryKey: claves.serviciosUsuario(tokenInfo.usuario),
        queryFn: async () => {
            const resp = await axios.get(`${BASE_URL}/servicios/usuario/${tokenInfo.usuario}`, cabecerasAuth());
            return resp.data.servicios || [];
        },
        enabled: Boolean(tokenInfo.usuario),
    });

    const servicios = consultaServicios.data || [];
    const cargando = consultaServicios.isPending;
    const error = consultaServicios.isError ? t('servicios.errorCargar') : null;

    if (cargando) return <div className="loader-fullscreen"><Loader /></div>;

    if (tokenInfo.estado === 'verificar') return <Verificacion />;
    if (tokenInfo.estado === 'suspendido') return <Suspendido />;

    return (
        <main className="site-width">
            <div className="pagina-cabecera">
                <h2>{t('servicios.titulo')}</h2>
                <p>{t('servicios.subtitulo')}</p>
            </div>

            {error && <p className="error">{error}</p>}

            {!error && servicios.length === 0 && (
                <div className="estado-vacio-card">
                    <FiInbox />
                    <p>{t('servicios.sinServicios')}</p>
                    <span>{t('servicios.sinServiciosNota')}</span>
                    <button type="button" onClick={() => navigate('/nuevo-ticket')}>
                        {t('servicios.abrirTicket')}
                    </button>
                </div>
            )}

            {!error && servicios.length > 0 && (
                <div className="srv-grid">
                    {servicios.map((servicio) => {
                        const { label, icon: Icono } = metaCategoria(servicio.categoria);
                        return (
                            <article key={servicio.id} className={`srv-card srv-card--${servicio.categoria}`}>
                                <div className="srv-card-cabecera">
                                    <span className={`srv-categoria srv-categoria--${servicio.categoria}`}>
                                        <Icono /> {label}
                                    </span>
                                    {servicio.horas !== null && typeof servicio.horas !== 'undefined' && (
                                        <span className="srv-horas"><FiClock /> {servicio.horas} h</span>
                                    )}
                                </div>

                                <h3 className="srv-card-titulo">{servicio.titulo}</h3>

                                {servicio.descripcion?.length > 0 && (
                                    <ul className="srv-card-lista">
                                        {servicio.descripcion.map((punto, i) => (
                                            <li key={i}><FiCheck /> <span>{punto}</span></li>
                                        ))}
                                    </ul>
                                )}
                            </article>
                        );
                    })}
                </div>
            )}
        </main>
    );
};

export default Servicios;
